import ScheduleDoctors from 'www/modules/Schedule/classes/ScheduleDoctors'

new ScheduleDoctors({
  doctorPageType: 'doctor-list',
  selectorContainersSlots: '.b-doctor-card__appointment-calendar',
  selectorContainerObserver: '[data-cards-list-container]',
})
